<template>
  <div class="menu-page">
    <v-card class="mb-4 nd-border" flat>
      <v-card-title class="d-flex justify-space-between">
        {{ webhook.name || 'Webhook'}}
        <router-link to="/webhooks">
          <ib-btn small color="gray200">
            <v-icon left>mdi-keyboard-backspace</v-icon>
            Voltar
          </ib-btn>
        </router-link>
      </v-card-title>
       
      <v-card-subtitle class="d-flex align-center flex-wrap">
        <span class="mr-2 break-word">URL do webhook: {{ webhook.url }}</span>
        <v-btn small v-if="!copyUrl" icon class="copy-btn" @click="copyToClipboard">
          <v-icon size="16">mdi-content-copy</v-icon>
        </v-btn>

        <v-btn small v-else icon class="copy-btn">
          <v-icon size="16">mdi-check</v-icon>
        </v-btn>
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6">
            <ib-text-field v-model="webhook.name" label="Nome" outlined hide-details="auto" />
          </v-col>

          <v-col cols="12" lg="6">
            <ib-autocomplete v-model="webhook.chip" outlined :items="chips" item-text="name" no-data-text="Não há números conectados" item-value="_id" label="Selecione um chip de envio" hide-details="auto" />
          </v-col>

          <v-col cols="12" lg="6">
            <ib-autocomplete v-model="webhook.flow" outlined :items="flows" item-text="name" no-data-text="Não há fluxos criados" item-value="_id" label="Selecione um fluxo" hide-details="auto" />
          </v-col>

          <v-col cols="12" lg="6">
            <ib-select v-model="webhook.status" outlined chips small-chips :items="statusOptions" item-text="label" item-value="value" label="Mude o status" hide-details="auto">
              <template #selection="{ item }">
                <ib-chip small :color="item.color">{{ item.label }}</ib-chip>
              </template>
              <template #item="{ item }">
                <ib-chip small :color="item.color">{{ item.label }}</ib-chip>
              </template>
            </ib-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-title>
        Dados do Webhook
        <v-spacer />
        <div class="d-flex">
          <ib-btn color="primary" outlined class="mr-2" small @click="webhookDataString = JSON.stringify(exampleJson, null, 4);">
            <v-icon left>mdi-database-arrow-down</v-icon>
            Exemplo
          </ib-btn>
          <ib-btn color="primary" small @click="handleTestEvent()">
            <v-icon left v-if="!loadingTestEvent">mdi-flask-outline</v-icon>
            <v-icon left v-else class="mr-1 animate-spin">mdi-loading</v-icon>
            {{ loadingTestEvent ? 'Aguardando evento...' : 'Receber evento teste' }}
          </ib-btn>

          <ib-btn v-show="loadingTestEvent" color="primary" class="ml-2" icon outlined small @click="endSocket()">
            <v-icon size="21">mdi-stop</v-icon>
          </ib-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-textarea v-model="webhookDataString" class="nd-text-field" rows="6" label="Dados recebidos" placeholder="Cole aqui o JSON do Webhook ou aguarde um evento de teste" outlined hide-details="auto" />
      </v-card-text>

      <v-card-title>Campos Mapeados</v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-for="(field, index) in webhook.fields" :key="index" cols="12" lg="6">
            <v-card class="d-flex flex-column pa-4 pb-8" style="gap: 20px; ">
              <v-row class="d-flex">
                <ib-btn :disabled="index === 0" class="ml-auto" icon small @click="webhook.fields.splice(index, 1)">
                  <v-icon color="red">mdi-close-circle-outline</v-icon>
                </ib-btn>
              </v-row>
              <ib-text-field v-model="field.name" label="Nome do campo" outlined hide-details="auto" :readonly="index === 0"/>

              <ib-autocomplete v-model="field.origin" :items="availablePaths" item-text="text" item-value="value" label="Campos de origem" multiple clearable chips small-chips outlined @change="updateValue(field)" hide-details="auto" :return-object="true" />

              <ib-text-field :value="field.value" label="Valor exemplo" readonly outlined hide-details="auto" />
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-center">
            <ib-btn color="primary" small @click="webhook.fields.push({ name: '', origin: [], value: '' });" >
              <v-icon left>mdi-plus</v-icon>
              Novo campo
            </ib-btn>
          </v-col>
        </v-row>

        <div class="d-flex justify-space-between mt-4">
          <ib-btn color="gray200" @click="load()">
            <v-icon left>mdi-cancel</v-icon>
            Cancelar
          </ib-btn>
          <ib-btn :loading="loading" color="primary" @click="updateWebook()">
            <v-icon left>mdi-content-save-outline</v-icon>
            Salvar
          </ib-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

let socket; // Variável para a instância do socket
let socket_connection_count = 0; // Controle de tentativas de conexão

export default {
  name: "WebhookSingle",

  data() {
    return {
      webhook: {},
      chips: [],
      validChips: [],
      flows: [],
      loading: false,
      dialogCreate: false,
      statusOptions: [
        { value: 'active', label: 'Ativo', color: '#0B9055' },
        { value: 'inactive', label: 'Inativo', color: '#9E9E9E' },
        { value: 'test', label: 'Teste', color: '#1976D2' }
      ],
      exampleJson: {
        user: {
          id: "12345",
          name: "João Silva",
          phone: {
            ddi: "55",
            number: "18993322541"
          }
        },
        order: {
          total: 99.90,
          date: "2025-07-01",
          status: 'approved'
        }
      },
      availablePaths: [],
      webhookDataString: '',
      copyUrl: false,
      loadingTestEvent: false,
      eventTimeout: null,
      debounceTimer: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },

    webhookId() {
      return this.$route.params.webhookId
    }
  },

  watch: {
    webhookDataString(newValue) {
      this.processWebhookJson(newValue);
    }
  },

  async mounted() {
    if (!this.currentUser?.access_areas?.includes('api')) {
      emitToastr("error", "Permissões insuficientes.");
      this.$router.replace({ name: 'Atendimento' });
    }

    this.load();
  },

  async beforeDestroy() {
    if (socket) {
      this.endSocket();
    }
  },

  methods: {
    extractJsonPaths(obj, prefix = '') {
      return Object.entries(obj).reduce((acc, [key, val]) => {
        const path = prefix ? `${prefix}.${key}` : key;
        if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
          return acc.concat(this.extractJsonPaths(val, path));
        } else {
          return acc.concat({ path, value: String(val) });
        }
      }, []);
    },

    updateValue(field) {
      const pathsList = this.extractJsonPaths(JSON.parse(this.webhookDataString));
      const lookup = pathsList.reduce((m, item) => { m[item.path] = item.value; return m; }, {});
      field.value = field.origin.map(p => lookup[p.value] || '').filter(v => v !== '').join('');     
    },

    processWebhookJson(jsonString) {      
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        try {
          const parsed = JSON.parse(jsonString);
          this.webhookDataString = jsonString;
          this.availablePaths = this.extractJsonPaths(parsed).map(item => ({
            text: `${item.path}: ${item.value}`,
            value: item.path
          }));          
          this.webhook.fields.forEach(field => { this.updateValue(field) });
        } catch (e) {
          this.availablePaths = [];
          this.webhook.fields.forEach(field => { field.value = null });
          emitToastr('error', 'O conteúdo fornecido não é um JSON válido.');
        }
      }, 1200);
    },

    async load() {
      this.loading = true;
      const webhook = await Api.getWebhookById(this.webhookId);

      if (!webhook.error && webhook.message) {
        this.webhook = webhook.message;                  

        if (this.webhook.data || this.webhook.field) {          
          this.webhookDataString = JSON.stringify(this.webhook.data, null, 4)
          this.availablePaths = this.extractJsonPaths(this.webhook.data).map(item => ({ text: `${item.path}: ${item.value}`, value: item.path }));
        }

        const existingTelefoneField = this.webhook.fields?.find(f => f.name === 'telefone');
          this.webhook.fields = [
            {
              name: 'telefone',
              origin: existingTelefoneField?.origin || [],
              value: existingTelefoneField?.value || null
            },
            ...(this.webhook.fields?.filter(f => f.name !== 'telefone') || [])
          ]
      }

      const chips = await Api.getChipNumbersByUser();

      if (!chips.error && chips.message) {
        this.chips = chips.message;
        this.validChips = [];
        let hasConnection = false;

        chips.message.forEach(chip => {
          if (chip.status == 'open') {
            this.validChips.push(chip.name);
            hasConnection = true;
          }
        });

        if (!hasConnection) this.showAlert = true;
      }

      const flows = await Api.getFlowsByUser();
      if (!flows.error && flows.message) {
        this.flows = flows.message;
      }

      this.loading = false;
    },

    async updateWebook() {     
      if (this.webhook.fields[0]?.origin.length === 0) return emitToastr('error', 'O campo telefone deve ser mapeado.');
      
      try {
        this.webhook.data = JSON.parse(this.webhookDataString);
      } catch (error) {
        return emitToastr('error', 'O conteúdo recebido do webhook não é um JSON válido.');
      }

      this.loading = true;
      const resp = await Api.createOrUpdateWebhook(this.webhook);
      this.loading = false;

      if (resp.error && resp.message) {
        return emitToastr("error", resp.message)
      }

      emitToastr("success", "Webhook atualizado!");
      this.load();
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.webhook.url);
      this.copyUrl = true;
      setTimeout(() => {
        this.copyUrl = false;
      }, 1500);
    },

    handleTestEvent() {
      if (this.webhook.status !== 'test') return emitToastr("error", "Webhook deve estar no status teste.");

      this.startSocket();
      this.loadingTestEvent = true;

      this.eventTimeout = setTimeout(() => {
        this.endSocket();
        emitToastr("warning", "Tempo esgotado. Nenhum evento recebido.");
      }, 60000);
    },

    startSocket() {      
      if (socket_connection_count >= 3) {
        emitToastr("error", "Erro na conexão com o socket. Atualize a página.");
        return;
      }

      if (!this.$store.state.SOCKET_IO_URL) {
        socket_connection_count++;
        setTimeout(() => { this.startSocket(); }, 500 + socket_connection_count * 2000);
        return;
      }

      socket_connection_count = 0;
      socket = this.$io(this.$store.state.SOCKET_IO_URL, { path: '/sock/' });

      socket.on("connect", () => {
        socket.emit("join-room", `webhook_${this.webhook._id}`);
      });

      socket.on("receive-message", data => {
        this.webhook.data = data.payload;
        this.webhookDataString = JSON.stringify(data.payload, null, 4);
        this.processWebhookJson(this.webhookDataString)
        this.endSocket();
      });
    },

    endSocket(){
      this.loadingTestEvent = false;
      clearTimeout(this.eventTimeout);

      socket.disconnect();
      socket = null;
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.break-word {
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>